<template>
  <div>
    <div>
      <section class="toolbar">
        <div class="toolbar-container">
          <router-link id="back-button-cyclerules" v-bind:to="'/operator/home-page'"><img src="/static/images/back.png"></router-link>
          <h1>Asset Manager</h1>
        </div>
      </section>
    </div>

    <div class="clearfix"></div>
    <section class="tab-container half-width-menu">
      <div id="custom-tab">
        <ul class="nav nav-pills">
          <li class="active">
            <a id="list_vin" href="#list_asset_tab" data-toggle="tab">List Asset</a>
          </li>
          <li>
            <a id="add_vin" href="#add_asset_tab" data-toggle="tab">Add Asset</a>
          </li>
        </ul>
        <div class="tab-content clearfix">
          <div class="tab-pane active" id="list_asset_tab">
            <div class="list-container">
              <div v-if="noAssets" class="custom-no-assets">No assets added by you<br>

              </div>
              <ul v-else id="vehicles_list" class="add-asset-list-container">

                <li v-for="val in items" :id="'asset-'+val.id" v-bind:key="val.id" v-on:click="vehicleSelected(val)">
                  <div class="list-view-left" v-if="val.unit_number_id">{{ val.vin }} ({{ val.unit_number_id }})</div>
                  <div class="list-view-left" v-else>{{ val.vin }}</div>
                  <div class="list-view-right">
                    <!-- {{if eq $.selected_vehicle $val.Vin}} -->
                    <img v-if="ifSelectedVehicleEqual" src="/static/images/tick-color.png">
                    <!-- {{else}} -->
                    <img v-if="ifSelectedVehicleNotEqual" src="/static/images/tick.png">
                    <!-- {{end}} -->
                  </div>
                </li>
                <!-- {{end}} -->
              </ul>
            </div>
          </div>
          <div class="tab-pane" id="add_asset_tab">
            <div class="col-md-12">
              <div class="widget-wrap">
                <div class="tab-container col-md-12 custom-padding0">
                  <form class="form-inline " id="operator_profile_form">
                    <input type="hidden" id="add_mapping" name="add_mapping" value="true">
                    <div class="group">
                      <div class="select-style">
                        <select name="company_id" id="company_id" class="form-control">
                          <option id="inspection-type-none" value="none" selected>None</option>
                          <template v-for="val in companyList">
                            <option :id="val.id" :value="val.id" v-bind:key="val.id" :data-name="val.name">{{val.name}}</option>
                          </template>
                        </select>
                      </div>
                      <span class="highlight"></span>
                      <span class="bar"></span>
                      <label for="inspectioin_type">Select Company: <span class="error-star">*</span></label>
                    </div>
                    <div class="group">
                      <input type="text" id="vin" name="vin">
                      <span class="highlight"></span>
                      <span class="bar"></span>
                      <label for="vin_name">Vin: <span class="error-star">*</span></label>
                    </div>
                    <div class="group">
                      <input type="text" id="year" name="year">
                      <span class="highlight"></span>
                      <span class="bar"></span>
                      <label for="dot">Year:</label>
                    </div>
                    <div class="group">
                      <input type="text" id="inservice" name="inservice">
                      <span class="highlight"></span>
                      <span class="bar"></span>
                      <label for="">In Service <span class="error-star">*</span></label>
                    </div>
                    <div class="group">
                      <input type="text" id="meter" name="meter">
                      <span class="highlight"></span>
                      <span class="bar"></span>
                      <label for="address">Meter:</label>
                    </div>
                    <div class="group">
                      <input type="text" id="mfg" name="mfg">
                      <span class="highlight"></span>
                      <span class="bar"></span>
                      <label for="address">Manufacturer:</label>
                    </div>
                    <div class="group">
                      <input type="text" id="model" name="model">
                      <span class="highlight"></span>
                      <span class="bar"></span>
                      <label for="address">Model:</label>
                    </div>
                    <div class="group">
                      <input type="text" id="type" name="type">
                      <span class="highlight"></span>
                      <span class="bar"></span>
                      <label for="address">Type:</label>
                    </div>
                    <div class="group">
                      <div class="select-style">
                        <select name="status" id="status" class="form-control">
                          <option value="active">Active</option>
                          <option value="inactive">Inactive</option>
                        </select>
                      </div>
                    </div>
                    <div class="group">
                      <input type="text" id="from_date" name="from_date">
                      <span class="highlight"></span>
                      <span class="bar"></span>
                      <label for="">From Date <span class="error-star">*</span></label>
                    </div>
                    <div class="group">
                      <input type="text" id="to_date" name="to_date">
                      <span class="highlight"></span>
                      <span class="bar"></span>
                      <label for="">To Date <span class="error-star">*</span></label>
                    </div>

                    <button type="button" v-on:click="addvin()" class="btn btn-primary custom-btn">Save</button>
                    <!--<button id="update-profile" type="button" class="btn btn-primary" v-on:click="updateProfile()">Update</button>-->
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data: () => ({
    companyList: [],
    companyListSize: 0,
    ifSelectedVehicleEqual: false,
    ifSelectedVehicleNotEqual: true,
    items: [],
    noAssets: false
  }),
  mounted() {
    /*let editor = this.$refs.editor;
        this.iframe.style = {
            position: 'absolute',
            width: window.innerWidth,
            height: window.innerHeight,
            top: -editor.offsetTop + "px",
            left: -editor.offsetLeft + "px",
        }
        this.iframe.wrapperStyle = {
            overflow: 'hidden',
            height: editor.clientHeight + "px",
            width: editor.clientWidth + "px",
        }
        this.loaded = true;*/
    $("#inservice").datetimepicker({
      useCurrent: true,
      format: "YYYY-MM-DD"
    });
    $("#from_date").datetimepicker({
      // useCurrent: true,
      maxDate: moment(),
      defaultDate : moment(),
      format: "YYYY-MM-DD"
    });
    $("#to_date").datetimepicker({
      minDate: moment(),
      useCurrent: false,
      format: "YYYY-MM-DD"
    });
    this.call();
  },
  methods: {
    call: function() {
      var self = this;
      self.$config.loading = true;
      $.ajax({
        url: self.$config.API + "/operator/company/companylist",
        type: "GET",
        crossDomain: true,
        xhrFields: {
          withCredentials: true
        },
        success: function(data) {
          if (data.status == "success") {
            self.companyList = data.data.companies;
            self.companyListSize = self.companyList.length;
            self.getAssets();
          } else {
            self.companyListSize = 0;
            alert("There was an error getting company list.");
          }
        },
        error: function(jqXHR, exception, textstatus) {
          self.$config.loading = false;
          //if session expired
          if (textstatus === "timeout") {
            alert("Request timeout");
          } else if (jqXHR.responseJSON.code == 401) {
            self.$router.push("/v1/operator/login");
          } else if (jqXHR.responseJSON.code == 400) {
            alert(jqXHR.responseJSON.message);
          }
        }
      });
    },
    getAssets: function() {
      var self = this;
      $.ajax({
        url: self.$config.API + "/v1/assets/asset-selection",
        type: "GET",
        crossDomain: true,
        xhrFields: {
          withCredentials: true
        },
        timeout: 10000,
        success: function(res) {
          self.$config.loading = false;
          var data = res.data;
          console.log(data.assets);
          if (res.status == "success") {
            self.items = data.assets;
            if (self.items == null) {
              self.noAssets = true;
            }
          }
        },
        error: function(jqXHR, exception) {
          self.$config.loading = false;
          //if session expired
          if (textstatus === "timeout") {
            alert("Request timeout");
          } else if (jqXHR.responseJSON.code == 401) {
            self.$router.push("/v1/operator/login");
          } else if (jqXHR.responseJSON.code == 400) {
            alert(jqXHR.responseJSON.messge);
          }
        }
      });
    },
    addvin: function() {
      var self = this;
      var form_data = $("form").serializeArray();
      var error_free = true;
      var elements_empty = "";
      for (var input in form_data) {
        var element = $("#" + form_data[input]["name"]);
        if (
          (element.attr("name") == "vin" && element.val() == "") ||
          (element.attr("name") == "company_id" && element.val() == "none") ||
          (element.attr("name") == "inservice" && element.val() == "") ||
          (element.attr("name") == "from_date" && element.val() == "") ||
          (element.attr("name") == "to_date" && element.val() == "")
        ) {
          console.log(element);
          if (elements_empty == "") {
            elements_empty = elements_empty + form_data[input]["name"];
          } else {
            elements_empty = elements_empty + "," + form_data[input]["name"];
          }
          error_free = false;
        } else {
        }
      }
      if (!error_free) {
        alert(
          elements_empty +
            " field(s) is/are mandatory, please do not leave them empty."
        );
        //event.preventDefault();
      } else {
        //alert('No errors: Form will be submitted');
        // addOperator();
        $(".form-actions .error").text("");
        $("form i").removeClass("error");

        var name = $("#name").val();
        var dot = $("#dot").val();
        if (name == "") {
          $(".form-actions .error").text("Name can not be empty");
          return;
        }
        /*if (dot == "") {
                $(".form-actions .error").text("Dot can not be empty")
                return;
            }*/
        var data = $("form").serialize();
        self.$config.loading = true;
        $.ajax({
          url: self.$config.API + "/admin/asset/add",
          type: "POST",
          data: data,
          crossDomain: true,
          xhrFields: {
            withCredentials: true
          },
          timeout: 10000,
          success: function(data) {
            self.$config.loading = false;
            if (data.message == "success") {
              $("form input,form textarea").val("");
              alert("Asset has been added successfully.");
              self.getAssets();
            } else {
              alert(data.message);
              $("form input,form textarea").val("");
              $(".form-actions .error").text(data.message);
              self.getAssets();
            }
          },
          error: function(data, textstatus) {
            self.$config.loading = false;
            alert("addition of asset failed : " + textstatus);
          }
        });
      }
    },
    vehicleSelected: function(obj) {
      var result = confirm("Are you sure to select this vehicle? " + obj.vin);
      if (result) {
        this.$router.push(
          "/operator/home-page?selected_vehicle=" + obj.id + "&vin=" + obj.vin
        );
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/addasset.vue